import { render, staticRenderFns } from "./SpecialPriceList.vue?vue&type=template&id=47f81ee0&"
import script from "./SpecialPriceList.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports